module.exports = __webpack_public_path__ + "media/images/nisiginzacc_icon-3bf85501546aa62ea46bca924ce013c9.jpg";